import {
  DocumentSchema,
  Document,
  Result,
  UploadDocumentPermission,
  UploadDocumentPermissionSchema,
} from '@/types/common';
import { ServiceError } from '@/types/service';
import { BootService } from '@/services/boot';
import { requestHandler, responseHandler } from '@/utilities/service';
import { z } from 'zod';

export async function uploadDocument(
  type: string,
  data: { file: File | null },
): Promise<Result<ServiceError, unknown>> {
  const formData = new FormData();
  if (data.file) {
    formData.append('file', data.file);
  }
  const headers = { ...BootService.getHeaders(), 'Content-Type': 'multipart/form-data' };
  return requestHandler(
    BootService.axios.post(`/document/${type}`, formData, { headers }).then(responseHandler(z.unknown())),
  );
}

export async function getDocument(type: string): Promise<Result<ServiceError, Document>> {
  return requestHandler(BootService.axios.get(`/document/${type}`).then(responseHandler(DocumentSchema)));
}

export async function checkUploadDocumentPermission(): Promise<Result<ServiceError, UploadDocumentPermission>> {
  return requestHandler(
    BootService.axios.get(`/document/editor/check`).then(responseHandler(UploadDocumentPermissionSchema)),
  );
}
